import { useState, useContext, useEffect } from 'react'

import { Box, Typography, Grid, RadioGroup, FormControlLabel, Radio, Button } from '@material-ui/core'

import { Autocomplete } from '@mui/material'
import { TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

import { reducerContext } from '../../../../../contextApi\'s/contextApi\'s'

import { withStyles } from '@material-ui/core/styles'
import styles from './callInterfaceStyles'

import { callTransferDepartmentInfo, callTransferAgentInfo } from '../../../../../helpers/callTransferDetails'

const renderOption = (props, user) => {
    return (
        <li {...props}>
            {user.departmentName || user.name} {user.departments && user.departments.length > 0 ? '-' : ''} {user.departments && user.departments.length > 0 ? user.departments[0].name : ''}
            {user?.agentStatus ? (
                <span
                    style={{
                        marginLeft: '3%',
                        borderRadius: '60%',
                        height: '12px',
                        width: '12px',
                        background: user.agentStatus === 'open' ? '#41AB1C' : 'red'
                    }}
                />
            ) : ''}
        </li>
    )
}

const TransferCall = ({ classes, handleTransferStatus, handleTransferText }) => {

    const { state, dispatch } = useContext(reducerContext)

    const { userData, additionalRoles } = state

    const [transferType, setTransferType] = useState('department')
    const [callTransferToggle, setCallTransferToggle] = useState(false)
    const [isFunctionCalled, setIsFunctionCalled] = useState(false)

    // Updated the SIP function to use async/await and added error handling - 15/10/24 - Dev Srini
    useEffect(() => {
        const callUserStatus = async () => {
            if (!isFunctionCalled && userData[0]?.email) {
                const noAgentStatus = userData.every(ele => ele.hasOwnProperty('agentStatus'))

                if (!noAgentStatus) {
                    try {
                        for (const ele of userData) {
                            if (ele.email && !ele.hasOwnProperty('agentStatus')) {
                                await window.sipUserStatus(ele.sip_id, 'rpid')
                            }
                        }
                        setIsFunctionCalled(true) // Set the flag to true once the function is called for all elements
                    } catch (error) {
                        console.error('Error calling SIP user status:', error)
                    }
                }
            }
        }
        callUserStatus()
    }, [userData])

    const handleTransferMode = (e) => {
        setTransferType(e.target.value)

        dispatch({
            type: 'SET_DEP_USER_DATA',
            payload: []
        })

        if (e.target.value === "department") {
            callTransferDepartmentInfo(dispatch)
        }
        if (e.target.value === "agent") {
            callTransferAgentInfo(dispatch)
        }
    }

    const handleSearchValue = (e, value) => {
        setCallTransferToggle(!callTransferToggle)

        if (value) {
            const selectedID = userData.find(ele => ele.sip_id === value.sip_id)

            const name = selectedID.name || selectedID.departmentName
            const department = selectedID.departments && selectedID.departments.length > 0 ? selectedID.departments[0].name : ''

            console.log(value.sip_id, name, department, 'handleAdditionalRoles')
            dispatch({
                type: 'SET_ADDITIONAL_ROLES',
                payload: value.sip_id
            })

            dispatch({
                type: 'SET_CALL_DOMAIN',
                payload: department ? `${name} ${department}` : name
            })

            handleTransferText()

            dispatch({
                type: 'SET_SHOW_DOMAIN',
                payload: true
            })
        }
    }

    const makeTransfer = async () => {
        window.txtPhoneNumber.value = additionalRoles

        try {
            await window.sipTransfer()
            console.log("Transfer successful.", additionalRoles)
        }
        catch(error) {
            console.error('Error during SIP transfer:', error)
        }

        dispatch({
            type: 'SET_SHOW_TRANSFER',
            payload: false
        })

        handleTransferStatus()
    }

    const handleTransferCallClose = () => {
        dispatch({
            type: 'SET_SHOW_TRANSFER',
            payload: false
        })
    }

    return (
        <Box className={classes.transferCallLayout}>
            <Typography className={classes.transferCallText} style={{ padding: '9% 0 0 6%' }}>
                Transfer Call To
            </Typography>

            <Grid
                className={classes.transferCallClose}
                onClick={handleTransferCallClose}
            >
                X
            </Grid>

            <Grid>
                <RadioGroup
                    row
                    defaultValue="department"
                    style={{ margin: '6% 0 0 6%' }}
                    value={transferType}
                    onChange={(e) => handleTransferMode(e)}
                >
                    <FormControlLabel
                        value="department"
                        control={<Radio />}
                        label={<Typography
                            className={classes.transferCallAgentText}
                        > Department </Typography>
                        }
                    />

                    <FormControlLabel
                        value="agent"
                        control={<Radio />}
                        label={<Typography
                            className={classes.transferCallAgentText}
                        >Agent</Typography>} />
                </RadioGroup>
            </Grid>

            <Grid>
                <Autocomplete
                    disablePortal
                    freeSolo
                    id="combo-box-demo"
                    options={userData}
                    getOptionLabel={(user) => `${user.departmentName || user.name} ${user.departments && user.departments.length > 0 ? '-' : ''} ${user.departments && user.departments.length > 0 ? user.departments[0].name : ''}`}

                    className={classes.transferCallSearchField}
                    onChange={handleSearchValue}
                    renderOption={renderOption}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Search By Department"
                            InputLabelProps={{
                                style: { fontFamily: 'cardiuma-regular', fontSize: '14px', marginTop: '-2%' }
                            }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {!params.inputProps.value && (
                                            <SearchIcon style={{ color: 'red', fontSize: 32, margin: '0 0 0% 6%', cursor: 'pointer' }} />
                                        )}
                                        {params.InputProps.endAdornment}
                                    </>
                                )
                            }}
                        />
                    )}
                />
            </Grid>

            <Grid>
                {callTransferToggle && <Button
                    className={classes.transferCallButton}
                    onClick={makeTransfer}
                >
                    <Typography
                        className={classes.transferCallButtonText}
                    >
                        Transfer
                    </Typography>
                </Button>}
            </Grid>
        </Box>
    )
}

export default withStyles(styles)(TransferCall)